angular.module('galilai.creator').controller('ImportPreviewController', function($scope, $rootScope, api, visual, parserService, $timeout) {

    const SAMPLE_PALETTES = [
        ["#002854", "#ffffff", "#d2b382"],
        ["#ffffff", "#0d83cf", "#40a9ed"],
        ["#fffaf8", "#100f0d", "#ff914d"],
        ["#073f89", "#ffffff", "#38b6ff"],
        ["#ffffff", "#023c6c", "#66ac4c"],
        ["#ffffff", "#120e11", "#c19a3a"],
        ["#ffffff", "#254656", "#d6ae33"],
        ["#ffffff", "#223342", "#ff914d"],
        ["#013c6a", "#ffffff", "#ff7401"],
        ["#ffffff", "#0a2449", "#fea106"],
        ["#ffffff", "#003264", "#43b0f1"],
        //["#000000", "#ffffff", "#ff964d"],
        //["#ffffff", "#202026", "#ff0000"],
        //["#ffffff", "#000000", "#fd8e49"],
        ["#282333", "#ffffff", "#ffde59"],
        ["#ffffff", "#000000", "#ffd015"],
        //["#050504", "#ffffff", "#ef3724"],
    ]

    const SAMPLE_PERSONS = [
        'https://galilai-bucket.s3.amazonaws.com/medias/682d1cae7010393fdc3b6eda.png',
        'https://galilai-bucket.s3.amazonaws.com/medias/6828f4f84eb437248c4da10c.png',
        "https://galilai-bucket.s3.amazonaws.com/medias/672e6476154b12675cba2665.png",
        "https://galilai-bucket.s3.amazonaws.com/medias/682e5046e1b1ca37573a3c2f.png",
        "https://galilai-bucket.s3.amazonaws.com/medias/682dfdf7b61b2d44c9b22262.png",
        "https://galilai-bucket.s3.amazonaws.com/medias/682b395eebdb341f6faff0e0.png",
        "https://galilai-bucket.s3.amazonaws.com/medias/682a0079f6dbd30720292ca1.png",
        "https://galilai-bucket.s3.amazonaws.com/medias/6829fe244ecf0207d72dfa37.png",
        "https://galilai-bucket.s3.amazonaws.com/medias/6827e62f189c970800f06ec1.png",
        "https://galilai-bucket.s3.amazonaws.com/medias/672e6476154b12675cba264b.png",
        "https://galilai-bucket.s3.amazonaws.com/medias/672e6476154b12675cba2637.png",
        "https://galilai-bucket.s3.amazonaws.com/medias/672e6476154b12675cba263e.png",
    ]

     const mapSizes = {
        'square': {
            width: 1,
            height: 1
        },
        'portrait': {
            width: 1,
            height: 1.25
        },
        'story': {
            width: 1,
            height: 1.777777777778
        },
    }
    const EXAMPLE_TITLES = [
        "<z00080040000 style=\"font-size: 18px;display: inline;border-radius: 100px;border: 1px solid #EL_TITLE;padding: 2px 8px\">Como </z00080040000><z01230000000 style=\"text-transform: uppercase;font-family: Instrument Serif, serif;font-size: 40px;display: block\">atrair clientes</z01230000000><z00080030000 style=\"font-size: 18px;display: inline;text-decoration: underline;text-decoration-color: #HIGHLIGHT\"> pelo Instagram</z00080030000>",
        "<z00080000000 style=\"font-size: 18px;display: inline\">Marketing simples que realmente </z00080000000><z01230000000 style=\"text-transform: uppercase;font-family: Instrument Serif, serif;font-size: 40px;display: block\">vende</z01230000000>",
        "<z00080000000 style=\"font-size: 18px;display: inline\">Erros que </z00080000000><z01250000000 style=\"text-transform: uppercase;font-family: Instrument Serif, serif;font-size: 30px;display: block\">travam suas vendas online</z01250000000>",
        "<z00080010000 style=\"font-size: 18px;display: inline;white-space: nowrap;border-radius: 8px;background: #HIGHLIGHT;padding: 2px 4px;color: #BWHIGHLIGHT\">Transforme </z00080010000><z00150000000 style=\"font-family: Antonio, sans-serif;font-size: 30px;display: block\">seguidores em clientes fiéis</z00150000000>",
        "<z00080000000 style=\"font-size: 18px;display: inline\">Dicas práticas pra </z00080000000><z01240000000 style=\"text-transform: uppercase;font-family: Instrument Serif, serif;font-size: 35px;display: block\">bombar seu negócio</z01240000000>",
        "<z00080030000 style=\"font-size: 18px;display: inline;text-decoration: underline;text-decoration-color: #HIGHLIGHT\">5 Dicas Pra </z00080030000><z01240000000 style=\"text-transform: uppercase;font-family: Instrument Serif, serif;font-size: 35px;display: block\">Bombar no Instagram</z01240000000>",
        "<z00080000000 style=\"font-size: 18px;display: inline\">7 </z00080000000><z00140000000 style=\"font-family: Antonio, sans-serif;font-size: 35px;display: block\">Erros Que Travam</z00140000000><z00080020000 style=\"font-size: 18px;display: inline;white-space: nowrap;margin: -2px -6px;padding: 4px 6px;background: url('https://s2.svgbox.net/pen-brushes.svg?ic=brush-1&color=#HIGHLIGHT');color: #BWHIGHLIGHT\"> Suas Vendas</z00080020000>",
        "<z00080010000 style=\"font-size: 18px;display: inline;white-space: nowrap;border-radius: 8px;background: #HIGHLIGHT;padding: 2px 4px;color: #BWHIGHLIGHT\">3 Passos Pra </z00080010000><z01240000000 style=\"text-transform: uppercase;font-family: Instrument Serif, serif;font-size: 35px;display: block\">Atrair Mais Clientes</z01240000000>",
        "<z00080000000 style=\"font-size: 18px;display: inline\">6 Ideias de </z00080000000><z00130000000 style=\"font-family: Antonio, sans-serif;font-size: 40px;display: block\">Conteúdo</z00130000000><z00080030000 style=\"font-size: 18px;display: inline;text-decoration: underline;text-decoration-color: #HIGHLIGHT\"> Que Convertem</z00080030000>",
        "<z00080000000 style=\"font-size: 18px;display: inline\">4 Estratégias Simples Pra </z00080000000><z00130000000 style=\"font-family: Antonio, sans-serif;font-size: 40px;display: block\">Vender Online</z00130000000>",
        "<z00080010300 style=\"font-size: 18px;display: inline;white-space: nowrap;border-radius: 8px;background: #HIGHLIGHT;padding: 2px 4px;color: #BWHIGHLIGHT\" class=\"break-after\">Mito ou verdade</z00080010300> <z00080000000 style=\"font-size: 18px;display: inline\">Postar </z00080000000><z01220000000 style=\"text-transform: uppercase;font-family: Instrument Serif, serif;font-size: 45px;display: block\">todo dia</z01220000000><z00080030000 style=\"font-size: 18px;display: inline;text-decoration: underline;text-decoration-color: #HIGHLIGHT\"> aumenta vendas?</z00080030000>",
        "<z00080010300 style=\"font-size: 18px;display: inline;white-space: nowrap;border-radius: 8px;background: #HIGHLIGHT;padding: 2px 4px;color: #BWHIGHLIGHT\" class=\"break-after\">Dúvida</z00080010300> <z00080000000 style=\"font-size: 18px;display: inline\">Preciso </z00080000000><z01230000000 style=\"text-transform: uppercase;font-family: Instrument Serif, serif;font-size: 40px;display: block\">pagar anúncios</z01230000000><z00080030000 style=\"font-size: 18px;display: inline;text-decoration: underline;text-decoration-color: #HIGHLIGHT\"> pra crescer?</z00080030000>",
        "<z00080040300 style=\"font-size: 18px;display: inline;border-radius: 100px;border: 1px solid #EL_TITLE;padding: 2px 8px\" class=\"break-after\">Mito ou verdade</z00080040300> <z00080000000 style=\"font-size: 18px;display: inline\">Mais seguidores significam </z00080000000><z01230000000 style=\"text-transform: uppercase;font-family: Instrument Serif, serif;font-size: 40px;display: block\">mais lucro?</z01230000000>",
        "<z00080040300 style=\"font-size: 18px;display: inline;border-radius: 100px;border: 1px solid #EL_TITLE;padding: 2px 8px\" class=\"break-after\">Mito ou verdade</z00080040300> <z00080000000 style=\"font-size: 18px;display: inline\">Reels funcionam pra </z00080000000><z01240000000 style=\"text-transform: uppercase;font-family: Instrument Serif, serif;font-size: 35px;display: block\">qualquer negócio?</z01240000000>",
        "<z00080040300 style=\"font-size: 18px;display: inline;border-radius: 100px;border: 1px solid #EL_TITLE;padding: 2px 8px\" class=\"break-after\">Mito ou verdade</z00080040300> <z00080000000 style=\"font-size: 18px;display: inline\">Hashtags trazem </z00080000000><z01250000000 style=\"text-transform: uppercase;font-family: Instrument Serif, serif;font-size: 30px;display: block\">novos clientes mesmo?</z01250000000>",
        "<em style=\"font-size:6rem;display:block;font-style:normal;font-weight:bold;line-height:normal;color:#HIGHLIGHT\" class=\"number-highlight\">5</em> Dicas Pra Bombar no Instagram",
        "<em style=\"font-size:6rem;display:block;font-style:normal;font-weight:bold;line-height:normal;color:#HIGHLIGHT\" class=\"number-highlight\">3</em> Erros Que Travam Suas Vendas",
        "<em style=\"font-size:6rem;display:block;font-style:normal;font-weight:bold;line-height:normal;color:#HIGHLIGHT\" class=\"number-highlight\">4</em> Passos Pra Atrair Mais Clientes",
        "<em style=\"font-size:6rem;display:block;font-style:normal;font-weight:bold;line-height:normal;color:#HIGHLIGHT\" class=\"number-highlight\">6</em> Ideias de Conteúdo Que Convertem",
        "<em style=\"font-size:6rem;display:block;font-style:normal;font-weight:bold;line-height:normal;color:#HIGHLIGHT\" class=\"number-highlight\">7</em> Estratégias Simples Pra Vender Online",
    ]
    const SIMPLE_TITLES = [
        "<em style=\"font-size:6rem;display:block;font-style:normal;font-weight:bold;line-height:normal;color:#HIGHLIGHT\" class=\"number-highlight\">5</em> Dicas Pra Bombar no Instagram",
        "<em style=\"font-size:6rem;display:block;font-style:normal;font-weight:bold;line-height:normal;color:#HIGHLIGHT\" class=\"number-highlight\">3</em> Erros Que Travam Suas Vendas",
        "<em style=\"font-size:6rem;display:block;font-style:normal;font-weight:bold;line-height:normal;color:#HIGHLIGHT\" class=\"number-highlight\">4</em> Passos Pra Atrair Mais Clientes",
        "<em style=\"font-size:6rem;display:block;font-style:normal;font-weight:bold;line-height:normal;color:#HIGHLIGHT\" class=\"number-highlight\">6</em> Ideias de Conteúdo Que Convertem",
        "<em style=\"font-size:6rem;display:block;font-style:normal;font-weight:bold;line-height:normal;color:#HIGHLIGHT\" class=\"number-highlight\">7</em> Estratégias Simples Pra Vender Online",
    ]
    const EXAMPLE_DESCRIPTIONS = [
        "Pequenos ajustes no seu conteúdo podem transformar curtidas em clientes reais.",
        "Descubra o que está impedindo suas redes de trazerem resultados de verdade.",
        "Você não precisa postar todo dia, precisa postar com estratégia.",
        "Aprenda a criar posts que geram conexão, não só visualizações.",
        "O segredo não é fazer mais, é fazer certo e com propósito.",
        "Venda mais mostrando quem você é.",
        "Pequenas ações, grandes resultados digitais.",
        "Seu conteúdo pode vender por você.",
        "Constância vence talento nas redes sociais.",
    ]
    const EXAMPLE_CTAS = [
        "Saiba Mais",
        "Confira Agora",
        "Quero Aprender",
        "Veja as Dicas",
        "Comece Já",
    ]
    let palletes = []
    SAMPLE_PALETTES.forEach(function(palette) {
        palletes.push({
            main: palette[0],
            text: palette[1],
            highlight: palette[2],
        })
        palletes.push({
            main: palette[1],
            text: palette[0],
            highlight: palette[2],
        })
    })

    $scope.size = 'portrait'

    $scope.state = {
        loading: false,
        template: null,
        aspect: 'portrait',
    }

    $scope.parsedPosts = []
    $scope.posts = []
    $rootScope.$on('import.templates.preview', function(event, params) {
        $scope.state.template = JSON.parse(JSON.stringify(params.template))
        if (params.paint) {
            $scope.state.template.paint = JSON.parse(JSON.stringify(params.paint))
        }
        if (params.classification) {
            $scope.state.template.classification = JSON.parse(JSON.stringify(params.classification))
        }

        if (params?.elements?.backgrounds) {
            // Check if any of bgs has slot == 'main' and if so compute ared (.computed . height, width (parse px))
            let mainBG = null
            for (let bg of params.elements.backgrounds) {
                if (bg.slot == 'main') {
                    mainBG = bg
                    break
                }
            }
            $scope.state.aspect = 'portrait'
            if (mainBG) {
                let width = parseInt(mainBG.computed.width.replace('px', ''))
                let height = parseInt(mainBG.computed.height.replace('px', ''))
                let aspect = width / height
                if (aspect > 1.2) {
                    $scope.state.aspect = 'horizontal'
                }
            }
        }

        angular.element('#import-preview-modal').modal('show')
        $scope.refresh()
    })

    function getElementById(elements, elementId) {
        if (!elementId) {
            return null
        }
        if (!elements) {
            return null
        }
        for (let element of elements) {
            if (element.id == elementId) {
                return element
            }
            if (element.elements) {
                let found = getElementById(element.elements, elementId)
                if (found) {
                    return found
                }
            }
        }
        return null
    }

    function isHorizontalLayout() {
        $scope.state.template
    }

    let counterPallete = 0
    $scope.refresh = function() {
        $scope.posts = []
        $scope.render()
        const probs = {
            'cta': 0.6,
            'address': 0.4,
            'phone': 0.5,
            'description': 0.8,
            'logo-image': 0.5,
        }

        EXAMPLE_TITLES.sort(() => 0.5 - Math.random())
        EXAMPLE_DESCRIPTIONS.sort(() => 0.5 - Math.random())
        EXAMPLE_CTAS.sort(() => 0.5 - Math.random())

        counterPallete = 0
        palletes = palletes.sort(() => 0.5 - Math.random())


        AVAILABLE_TITLES = EXAMPLE_TITLES
        if ($scope.state.aspect == 'horizontal') {
            AVAILABLE_TITLES = SIMPLE_TITLES
        }
        for (let i = 0; i < 12; i++) {
            template = {
                title: AVAILABLE_TITLES[i % AVAILABLE_TITLES.length],
                author: {
                    handle: '@logomarca.empresa',
                },
                price: {
                    before: 'Promo',
                    number: {
                        left: 'R$',
                        main: '99',
                        right: '90',
                    },
                    after: 'only today',
                }
            }
            if (Math.random() < probs['logo-image']) {
                template.author.logo = {
                    url: 'https://galilai-bucket.s3.amazonaws.com/creator/users/67c1eb45200f90727c7b756a/images/3b940510b6847db62aa4702afd07c4e6c3cfa99c.png?v=1761225837739',
                    enabled: true,
                    mode: 'watermark',
                }
            }
            template.image = 'https://images.pexels.com/photos/2041627/pexels-photo-2041627.jpeg'
            template.person = SAMPLE_PERSONS[i % SAMPLE_PERSONS.length]
            if (Math.random() < probs.description) {
                template.description = EXAMPLE_DESCRIPTIONS[i % EXAMPLE_DESCRIPTIONS.length]
            }
            if (Math.random() < probs.cta) {
                template.cta = EXAMPLE_CTAS[i % EXAMPLE_CTAS.length]
            }
            if (Math.random() < probs.address) {
                template.address = 'Av. Paulista, 1000 - São Paulo, SP'
            }
            if (Math.random() < probs.phone) {
                template.phone = '(11) 91234-5678'
            }
            addTemplate(template)
        }
    }

    function addTemplate(item, theme=BASE_THEME) {
        api.buildLayoutTemplate({
            template: $scope.state.template,
            item: item,
        }).then(function(response) {
            let layout = response.data.layout
            let post = {
                data: {
                    items: [
                        item,
                    ],
                    layouts: [ layout ],
                    theme: JSON.parse(JSON.stringify(theme)),
                }
            }
            post.data.theme.pallete = palletes[counterPallete % palletes.length]
            post.data.theme.size = mapSizes[$scope.size]
            if (!post.data.theme.global) {
                post.data.theme.global = {}
            }
            if (!post.data.theme.global.paint) {
                post.data.theme.global.paint = {}
            }
            post.data.theme.global.paint.enabled = true
            counterPallete++
            $scope.posts.push(post)
        }).finally(function() {
            $scope.render()
        })
    }

    $scope.render = function() {
        $scope.parsedPosts = $scope.posts.map(function(post, index) {
            // Update size
            post.data.theme.size = mapSizes[$scope.size]
            return parserService.getFullParsed(post, 0)
        })
        $timeout(angular.noop)
    }
})
